import formatMinutesSeconds from './formatMinutesSeconds';

export default function formatDaysHoursMinutesSeconds(seconds) {
  const secondsPerHour = 60 * 60;
  const secondsPerDay = 24 * secondsPerHour;

  const days = Math.floor(seconds / secondsPerDay);
  const remainingHours = Math.floor((seconds - days * secondsPerDay) / secondsPerHour);

  if (days <= 0) {
    if (remainingHours <= 0) {
      return formatMinutesSeconds(seconds);
    }
    return `${remainingHours} ${remainingHours > 1 ? 'hours' : 'hour'}`;
  }

  return `${days} ${days > 1 ? 'days' : 'day'}`;
}



// WEBPACK FOOTER //
// ./src/helpers/formatDaysHoursMinutesSeconds.js